import React from "react";
import GameSsoLoginCallBack from "Utils/GameSsoLoginCallBack";
import { useLocation } from "react-router-dom";
import AppSsoLoginCallBack from "Utils/AppSsoLoginCallBack";


const AppSsoCallBackGoogle = () => {
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let redirectUri = query.get("redirectUri");
    AppSsoLoginCallBack("google",getGameSvcCd,redirectUri);
    return(
        <></>
    )
}

export default AppSsoCallBackGoogle;